import { Event } from "event-system";
import { IRenderer } from "@pixi/core";
import { ICanvasScaler } from "./ICanvasScaler";

export class CanvasScaler implements ICanvasScaler {
    private renderer: IRenderer;
    public readonly referenceWidth: number;
    public readonly referenceHeight: number;
    public readonly referenceRatio: number;
    public readonly onResize: Event<Scales>;
    public get browserHeight(): number {
        return window.innerHeight;
    }
    public get browserWidth(): number {
        return window.innerWidth;
    }
    
    public constructor(renderer: IRenderer, width: number, height: number) {
        this.renderer = renderer;
        this.referenceWidth = width;
        this.referenceHeight = height;
        this.referenceRatio = width / height;
        this.onResize = new Event<Scales>();
        window.onresize = this.resize.bind(this);
        this.resize();
    }

    public getSize(): Scales {
        let width = this.browserWidth;
        let height = width / this.referenceRatio;
        if (height > this.browserHeight) {
            height = this.browserHeight;
            width = height * this.referenceRatio;
        }
        return new Scales(width, height);
    }

    public resize(): void {
        const scales = this.getSize();
        this.renderer.resize(this.browserWidth, this.browserHeight);
        this.onResize.emit(scales);
    }

    public get BASE_RESOLUTION(): { height: number, width: number } {
        return { height: this.referenceHeight, width: this.referenceWidth }
    }
}

export class Scales {
    public readonly height: number;
    public readonly width: number;

    public constructor(width: number, height: number) {
        this.height = Math.floor(height);
        this.width = Math.floor(width);
    }
}